//import { downloadJson } from "@/utils/downloadJson";
import axios from "./productInstance";
import { ProductProfileData } from "@/types/product";

const getProductProfile = async (id: string | undefined): Promise<ProductProfileData | null> => {
    try {
        if (!id || id === "") {
            return null;
        }

        const response = await axios.get<ProductProfileData>(`/productProfiles/${id}`);

        if (response && response.data) {
            return response.data;
        } else {
            return null;
        }
    } catch (error) {
        console.error("Error fetching product profile:", error);
        return null;
    }
};


export default getProductProfile;